// @flow

import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    height: "100%",
    padding: theme.spacing(2),
    textAlign: "center",
    position: "absolute",
  },
});

const SomethingWentWrong = ({ message, classes, onResolve }: Object) => {
  const defaultMessage =
    "Sorry! Unexpected error occurred. We are working on resolving the issue. You may refresh the page or try again later.";
  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      direction="column"
      justify="center"
      className={classes.root}
    >
      <Grid item>
        <Typography variant="h1" gutterBottom>
          Something went wrong!
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="h5" gutterBottom>
          {message || defaultMessage}
        </Typography>
      </Grid>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/"
          onClick={onResolve}
        >
          back home
        </Button>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(SomethingWentWrong);
